import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Auth } from 'src/app/models/auth';
import { FilterUseProducts } from 'src/app/models/relatorio';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ContratoService } from 'src/app/services/contrato.service';
import { RelatorioService } from 'src/app/services/relatorio.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { ExcelService, WorksheetData } from 'src/app/shared/services/excel.service';
import {saveAs} from 'file-saver';
import { FormControl } from '@angular/forms';
import { CedenteContrato } from 'src/app/models/cedente-contrato';
import { Subject } from 'rxjs';
import { map, filter, debounceTime, distinctUntilChanged, tap, switchMap, delay, takeUntil } from 'rxjs/operators';
import { ColaboradorService } from 'src/app/services/colaborador.service';
import { environment } from 'src/environments/environment';
import { PdfData, PdfService } from 'src/app/shared/services/pdf.service';
import { Product } from 'src/app/models/contract-assignor';

@Component({
  selector: 'app-saldo-detalhado',
  templateUrl: './saldo-detalhado.component.html',
  styleUrls: ['./saldo-detalhado.component.css']
})
export class SaldoDetalhadoComponent implements OnInit {

  constructor(
    private relatorioService: RelatorioService,
    private authenticationService: AuthenticationService,
    private collaboratorsService: ColaboradorService,
    private modalService: NgbModal,
    private alertService: NewAlertService,
    private contractService: ContratoService,
    public datepipe: DatePipe
  ) { }

  public currentUser: Auth;
  public filtro = new FilterUseProducts(null,null,null,null,null,false);

  public favorecidos: any[];
  public mes: any;
  public filtroOn: boolean = false;
  public searching = false;
  public collaboratorsFiltered: any;
  protected _onDestroy = new Subject<void>();

  assignorContractList: CedenteContrato[];
  productList: Product[];

  //#region filter form
  public productsCtrl: FormControl = new FormControl();
  public collaboratorsServerSideCtrl: FormControl = new FormControl();
  public collaboratorsServerSideFilteringCtrl: FormControl = new FormControl();

  public collaboratorsFilterText: string;
  public productsFilterText: string;

  // páginação
  currentPage = 1;
  showItem = '10';
  totalItems = 0;
  collumnName = "";
  queryDate: Date;
  
  ngOnInit() {
    this.currentUser = this.authenticationService.currentUserValue;

    //this.carregarRelatorio(1);
    this.getContracts();

    this.collaboratorsFiltered = this.collaboratorsServerSideFilteringCtrl.valueChanges
    .pipe(
      map(search => search.trim()),
      filter(search => search.length > 2 || !!search ),
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => this.searching = true),
      switchMap(search => {
        return this.collaboratorsService.getCollaboratorFilter(this.currentUser.token.assignorGuid, search)
      }),
      map((res: any) => {
        this.searching = false;
        return res.result;
      }),
      delay(500),
      takeUntil(this._onDestroy)
    );
  }

  carregarRelatorio(page){
    this.currentPage = page;
    this.relatorioService.getDetailedBalance(this.currentUser.token.assignorGuid,(page-1),+this.showItem,this.filtro)
    .subscribe(response => {
      if (response.status === ApiError.Sucesso) {
        this.favorecidos = response.result.detailedBalance;
        this.totalItems = response.result.total;
        this.queryDate = response.result.queryDate;

        for (const s of this.favorecidos) {;
          const tam = environment.TOTAL_CARACTERE_CPF - s.document.toString().length;
          let str = s.document.toString();

          for (let i = 0; i < tam; i++) { str = '0' + str; }

          s.document = str;
        }
      }
    });
  }  
  
  getContracts(){
    this.contractService.getContractsAssignorProducts(this.currentUser.token.assignorGuid).subscribe(
      response => {
        if (response.status === ApiError.Sucesso) {
          this.productList = response.result;
          if (this.productList.length <= 0 && this.productList.length <= 0) {
            this.alertService.error(response.message);
          }
        } else {
          this.alertService.error(response.message);
        }
      },
      error => {
        this.alertService.error('Erro ao carregar o filtro de produtos' + error);
      }
    );
  }

  showItemChanged(event) {
    this.showItem = event;
    this.carregarRelatorio(1);
  }

  showFilter(content: any) {
    this.modalService.open(content, { centered: true, size: 'lg' });
  }

  applyFilter() {
    this.filtro.collaboratorsId = [];
    this.collaboratorsFilterText = '';
    this.productsFilterText = '';
    let colla = this.collaboratorsServerSideCtrl.value;
    this.filtro.productsId = this.productsCtrl.value;

    colla?.forEach((x, i) => {
      if(this.filtro.collaboratorsId.indexOf(x.id) == -1){
        this.filtro.collaboratorsId.push(x.id);
        this.collaboratorsFilterText += i==0 ? x.name : ', ' + x.name;
      }
    });
    
    this.filtro.productsId?.forEach((x, i)=> {
      this.productsFilterText += i==0 ?this.getProduct(x) : ', ' + this.getProduct(x);
    });

    if(
      this.filtro.productsId == null &&
      (this.filtro.collaboratorsId == null || this.filtro.collaboratorsId.length == 0)
    ){
      this.filtroOn = false;
      //this.carregarRelatorio(1);
      this.modalService.dismissAll();
    } else {
      this.filtroOn = true;
      this.carregarRelatorio(1);
      this.modalService.dismissAll();
    }
  }

  deleteFilter(){
    this.filtro.productsId = null;
    this.filtro.collaboratorsId = null;
    this.productsCtrl.setValue(null);
    this.collaboratorsServerSideCtrl.setValue(null);
    this.filtroOn = false;    
    this.favorecidos = [];
    this.currentPage = 1;
    this.totalItems = 0;
    //this.carregarRelatorio(1);
  }

  exportExtractExcel(){
    var result = [];
    let date: any = new Date();
    date = date.toLocaleDateString('pt-BR');
    date = date.split('/');

    const excelService = new ExcelService();
    const worksheets = new Array<WorksheetData>();
    const ws = new WorksheetData();
    ws.worksheetTitle = 'relatorio_saldo_detalhado_' + date[2] + '-' + date[1] + '-' + date[0];
    ws.worksheetHeaders = ['Data','Favorecido','Produto','Valor'];
    ws.WorksheetRows = [];
    // /*
    this.relatorioService.getDetailedBalance(this.currentUser.token.assignorGuid,0,+this.totalItems,this.filtro)
    .subscribe(response => {
      if (response.status === ApiError.Sucesso) {
        result = response.result.detailedBalance;

        result.forEach((r) => {
          const lr = new Array<string>();
          lr.push(this.formatarCpf(r.document));
          lr.push(r.collaborator);
          lr.push(r.product);
          lr.push(r.value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }));
          ws.WorksheetRows.push(lr);
        });

        worksheets.push(ws);

        let filter = '';
        filter += this.filtro.collaboratorsId?.length > 0 ? 'Favorecidos: ' + this.collaboratorsFilterText + ' - ': ''
        filter += this.filtro.productsId?.length > 0 ? 'Produtos: ' + this.productsFilterText : ''

        excelService.generateExcelReport('Saldo detalhado', worksheets, filter).xlsx
        .writeBuffer().then((data) => {
          const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          saveAs(blob, ws.worksheetTitle + '.xlsx');
        });

      }
    },
    error => {
      this.alertService.error('Ocorreu um erro ao paginar relatorio');
    });
    // */
  }

  exportExtractPdf(){
    let result = [];
    let date: any = new Date();
    date = date.toLocaleDateString('pt-BR');
    date = date.split('/');

    const pdfData = new PdfData();
    pdfData.PdfTitle = 'relatorio_saldo_detalhado_' + date[2] + '-' + date[1] + '-' + date[0];
    pdfData.PdfHeaders = ['Data','Favorecido','Produto','Valor',''];
    pdfData.PdfRows = [];

    this.relatorioService.getDetailedBalance(this.currentUser.token.assignorGuid,0,+this.totalItems,this.filtro)
    .subscribe(response => {
      if (response.status === ApiError.Sucesso) {
        result = response.result.detailedBalance;

        result.forEach((r) => {
            const lr = new Array<string>();
            lr.push(this.formatarCpf(r.document));
            lr.push(r.collaborator);
            lr.push(r.product);
            lr.push('R$');
            lr.push(r.value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }));
            pdfData.PdfRows.push(lr);
        });

        let filter = '';
        filter += this.filtro.collaboratorsId?.length > 0 ? 'Favorecidos: ' + this.collaboratorsFilterText : ''
        filter += this.filtro.productsId?.length > 0 ? (filter == '' ? '' : ' - ') + 'Produtos: ' + this.productsFilterText : ''

        const pdfService = new PdfService();
        pdfService.generatePdfReport('Saldo detalhado',pdfData,filter,this.datepipe.transform(this.queryDate, 'dd/MM/yyyy HH:mm:ss')).getBlob((blob) => {
          saveAs(blob, pdfData.PdfTitle + '.pdf');
        });

      } else {
        this.alertService.error(response.message);
      }
    },
    error => {
      this.alertService.error(
        'Ocorreu um erro ao paginar o relatorio'
      );
    });
  }

  formatarCpf(cpf){
    if(cpf == null)
      return null
      
    const tam = environment.TOTAL_CARACTERE_CPF - cpf.toString().length;

    for (let i = 0; i < tam; i++) { cpf = '0' + cpf; }

    return cpf.slice(0,3)+"."+cpf.slice(3,6)+"."+cpf.slice(6,9)+"-"+cpf.slice(9);
  }

  getProduct(item){
    return this.productList.find(x => x.produtoId == item).descricaoProduto;
  }
}